import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { DataLake } from "@graylog/enterprise-api";
const streamDataLakeEnabledStatus = create({
  fetcher: (ids) => DataLake.getEnabledStreamStatuses({ stream_ids: ids }),
  resolver: keyResolver("stream_id"),
  scheduler: windowScheduler(10)
});
const useStreamDataLakeEnabledStatus = (streamId) => {
  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: ["data-lake-config", streamId, "enabled"],
    queryFn: () => streamDataLakeEnabledStatus.fetch(streamId),
    placeholderData: keepPreviousData
  });
  return {
    data: data == null ? void 0 : data.enabled,
    refetch,
    isFetching,
    isError
  };
};
export default useStreamDataLakeEnabledStatus;
